import { Check } from "lucide-react";

export function SiteFeatureList({ features }: { features: readonly string[] }) {
  return (
    <ul className="mt-8 grid gap-3 sm:grid-cols-2">
      {features.map((feature) => (
        <li key={feature} className="flex items-start gap-3 text-sm text-foreground/85">
          <span className="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full border border-border bg-secondary/50 text-primary">
            <Check className="size-3.5" strokeWidth={1.6} />
          </span>
          <span className="leading-relaxed">{feature}</span>
        </li>
      ))}
    </ul>
  );
}
